import { BACKEND } from '@constant/constant';
import axios from 'axios';

export const webapi = axios.create({
  baseURL: `${BACKEND}/api`,
  withCredentials: true,
  headers: {
    'Content-type': 'application/json',
  },
});

export default axios.create({
  baseURL: `${BACKEND}/api`,
  withCredentials: true,
  headers: {
    'Content-type': 'application/json',
  },
});

export const APIEndpointWeb = {
  /**
   * @public
   */
  /**
  //  * @method get
  //  * @param group_id string
  //  * @param group_owner_id string
   */

  GetInsurance: '/v1/users/get-request',
  /**
   * @method get
   */
  GetCheckHistory: '/v1/users/process-check-history',
  /**
   * @method get
   */
  GetConsent: '/v1/users/get-consent',
  /**
   * @method get
   */
  GetProcessStatus: '/v1/users/process-status',
  /**
   * @method get
   */
  GetSignHistory: '/v1/medic/sign-history-success',
  /**
   * @method get
   */
  GetAccessToken: '/v1/shared-token/to-access-token',
  /**
   * @method get
   */
  GetInfo: '/v1/shared-token/get-info',
  /**
   * @method get
   */
  GetCookie: '/v1/insurance/cookie',
  /**
   * @method get
   */
  PostInsertRequest: '/v1/insurance/insert-request',
  /**
   * @method post
   */
  GetHistoryRefcode: '/v1/insurance/get-history-by-refcode',
  /**
   * @method get
   */
  PostMedicalHistory: '/v1/users/request-medical-history',
  /**
   * @method post
   */
  GetStatusAgent: '/v1/insurance/process',
  /**
   * @method get
   */
  GetMedPending: '/v1/medic/sign-in-progress',
  /**
   * @method get
   */
  GetRefCode: '/v1/insurance/get-refcode',
  /**
   * @method get
   */
  GetCheckekyc: '/v1/shared-token/check-ekyc',
  /**
   * @method get
   */
  GetUserDisplay: '/v1/insurance/get-display',
  /**
   * @method get
   */
  GetSelectHospital: '/v1/insurance/get-hospital',
  /**
   * @method get
   */
  GetOTP: '/v1/shared-token/get-otp',
  /**
   * @method get
   */

  GetInsuranceNotify: '/v1/insurance/notify',
  /**
   * @method post
   */
  Login: '/v1/shared-token/login-pwd',
  /**
   * @method post
   */
  ResetPasswordByOTP: '/v1/shared-token/reset-password-by-otp',
  /**
   * @method post
   */
  ResetPasswordByEmail: '/v1/shared-token/reset-password-by-email',
  /**
   * @method post
   */
  ChangePassword: '/v1/shared-token/change-password',
  /**
   * @method post
   */
  RejectRequest: '/v1/insurance/reject-request',
  /**
   * @method post
   */
  DataDashboardMed: '/v1/medic/dashboard',
  /**
   * @method get
   */
  ProcessDashboardMed: '/v1/medic/process-status',
  /**
   * @method get
   */

  MedicGetusers: '/v1/medic/get-users',
  /**
   * @method get
   */
  UploadFilesJsonMed: '/v1/medic/upload-files',
  /**
   * @method post
   */
  DashboardInsurance: '/v1/insurance/get-summary',
  /**
   * @method get
   */
  RejectedRequest: '/v1/medic/rejected-request', //ปุ่ม comment ฝั่ง รพ
  /**
   * @method get
   */
  RequestIncomplete: '/v1/insurance/re-request/incomplete', //ปุ่ม comment ฝั่งประกัน
  /**
   * @method get
   */
  filterInsurer: 'v1/insurance/get-list/ref-code',
  /**
   * @method get
   */
  filterHospital: 'v1/insurance/filter-hospital',
  /**
   * @method get
   */
  checkDuplicate: 'v1/insurance/check-duplicate',
  /**
   * @method post
   */
  AdditionalDocuments: 'v1/medic/additional-documents ',
  /**
   * @method post
   */
  checkCookie: 'v1/shared-token/check-cookie ',
  /**
   * @method get
   */
  logout: 'v1/shared-token/logout ',
  /**
   * @method post
   */
  listusers: 'v1/insurance/manage-user/list-users',
  /**
  * @method get
  */
  detailuser: 'v1/insurance/manage-user/detail-user?id=',
  /**
  * @method get
  */
  adddetailuser: 'v1/insurance/manage-user/update/detail-user?id=',
  /**
 * @method put
 */
  deleteuser: 'v1/insurance/manage-user/delete-user?id=',
  /**
* @method delete
*/
  checkcid: 'v1/insurance/manage-user/check-cid ',
  /**
 * @method post
 */
  register: 'v1/insurance/manage-user/register',
  /**
 * @method post
 */
  checkNameIDCard: 'v1/insurance/get-name',
  /**
 * @method get
 */
  loginprovider: 'v1/shared-token/login-provider ',
  /**
 * @method post
 */
  ratingscore: 'v1/rating-score/insert ',
  /**
 * @method post
 */
  ticket: 'v1/ticket/insert ',
  /**
 * @method post
 */
  dashboardtable: 'v1/insurance/dashboard-table',
  /**
 * @method get
 */
  MedicNotification : 'v1/medic/notification',
  /**
 * @method get
 */
  CountNotification : 'v1/medic/count-notification',
  /**
 * @method get
 */
  MedicGetFiles : 'v1/medic/get-files',
  /**
 * @method get
 */
  // /api/v1/medic/get-files?document_id=67972bb36e5e60173a792687&file_type={{IDCard หรือ Consent หรือ Attachment}}
}